module.exports = __webpack_public_path__ + "img/PayamIbrahim-SmorayMihraban.a938f322.jpg";